import React from 'react';
import { Instagram, Youtube } from 'lucide-react';
const TikTokIcon = ({
  className = ''
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true" data-id="element-154" data-mp="3ggap9r3mg53c">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.65a8.16 8.16 0 0 0 4.77 1.52V6.69a4.85 4.85 0 0 1-1.84-.0z" data-id="element-155" data-mp="32p5kybpb6omo" />
  </svg>;
export function Footer() {
  return <footer className="bg-ink border-t border-gold/20 py-12" data-id="element-156" data-mp="36mrefh5qqqd">
      <div className="container mx-auto px-6" data-id="element-157" data-mp="3ldkcr17ga6oj">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-158" data-mp="3qdf415v50ya4">
          <div className="text-center md:text-left" data-id="element-159" data-mp="3qf9qwppyz0gu">
            <h3 className="font-serif text-2xl text-ivory-bright tracking-widest uppercase mb-1" data-id="element-160" data-mp="29y5gjzn2fiuh">
              Freddy Pimentel
            </h3>
            <p className="text-gold text-xs tracking-[0.2em] uppercase" data-id="element-161" data-mp="2evx8uurmh6z7">
              Coach · Mentor · Speaker
            </p>
          </div>

          <div className="flex items-center gap-6" data-id="element-162" data-mp="3gb8xv7n4lmxp">
            <a href="https://www.instagram.com/soyfreddypimentel?igsh=MTAxeHVlc3NkanppNA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-gold transition-colors" data-id="element-163" data-mp="3gctqgrpvqvsx">
              <Instagram className="w-5 h-5" data-id="element-164" data-mp="817bo10udgrf" />
              <span className="sr-only" data-id="element-165" data-mp="3477jvnjyo2y">Instagram</span>
            </a>
            <a href="https://youtube.com/@soyfreddypimentel?si=pRGBk8UMCQ5VC3mx" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-gold transition-colors" data-id="element-166" data-mp="3232vbhtxl1m">
              <Youtube className="w-5 h-5" data-id="element-167" data-mp="qujm3pdazj2i" />
              <span className="sr-only" data-id="element-168" data-mp="qrf67uqh6yw0">YouTube</span>
            </a>
            <a href="https://www.tiktok.com/@soyfreddypimentel?_r=1&_t=ZS-96SxL9ey6BI" target="_blank" rel="noopener noreferrer" className="text-muted hover:text-gold transition-colors" data-id="element-169" data-mp="mt7vbgip0rsq">
              <TikTokIcon className="w-5 h-5" data-id="element-170" data-mp="13tkd00sme5ce" />
              <span className="sr-only" data-id="element-171" data-mp="13rpu0s0wsnay">TikTok</span>
            </a>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted font-light" data-id="element-172" data-mp="18lk6pbi3k20j">
          <p data-id="element-173" data-mp="1hkfhl0w360a6">
            © {new Date().getFullYear()} Freddy Pimentel. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-4" data-id="element-174" data-mp="1mktlc6qnmo2e">
            <a href="#" className="hover:text-ivory transition-colors" data-id="element-175" data-mp="1mhpfz61gdma5">
              Términos y Condiciones
            </a>
            <a href="#" className="hover:text-ivory transition-colors" data-id="element-176" data-mp="3obew7peob6aa">
              Política de Privacidad
            </a>
          </div>
        </div>
      </div>
    </footer>;
}